<template>
  <div
    :class="[
      'fact-box',
      {
        'fact-box--border-dashed': hasBorderDashed,
        'fact-box--bg-green': hasBackgroundGreen,
      },
    ]"
  >
    <div class="fact-box__grid">
      <div class="fact-box__grid-left">
        <span class="fact-box__image-container" v-if="hasImageQuestionMark">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="31" v-bind:loading="'lazy'" v-bind:class="'fact-box__image'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#333" fill-rule="evenodd" d="M14.26 22.12h-.94c0-.7.02-1.27.07-1.71.05-.46.14-.85.28-1.2.15-.34.37-.68.66-1.02.3-.34.69-.74 1.18-1.2.95-.9 1.7-1.69 2.29-2.38a7.05 7.05 0 001.28-2.2c.27-.75.4-1.67.4-2.77 0-1.71-.45-3.05-1.36-4.02-.91-.97-2.2-1.45-3.88-1.45-1.65 0-2.94.49-3.85 1.48a5.72 5.72 0 00-1.42 3.92h-.81l-.05-.11a6.65 6.65 0 01.76-3.37 5.15 5.15 0 012.18-2.12 6.76 6.76 0 013.19-.73c1.92 0 3.43.59 4.54 1.77a6.56 6.56 0 011.65 4.66c0 1.1-.16 2.09-.48 2.97-.32.88-.8 1.73-1.46 2.54-.65.8-1.48 1.66-2.5 2.56-.5.44-.87.84-1.12 1.22-.25.37-.42.8-.5 1.27-.07.47-.11 1.1-.11 1.89zm.42 7h-1.43v-1.85h1.43v1.86z"/></svg>
        </span>
        <span class="fact-box__image-container" v-else>
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 31" v-bind:loading="'lazy'" v-bind:class="'fact-box__image idea-light-bubble'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><defs><path id="a" d="M0 .04h3.01v.67H0z"/></defs><g fill="none" fill-rule="evenodd"><path fill="#333" d="M13.95 4.82a9.52 9.52 0 100 19.04 9.52 9.52 0 000-19.04m0 .76c2.34 0 4.54.9 6.2 2.56s2.56 3.86 2.56 6.2-.91 4.54-2.56 6.2c-1.66 1.64-3.86 2.56-6.2 2.56s-4.54-.92-6.2-2.57a8.7 8.7 0 01-2.56-6.2 8.7 8.7 0 012.57-6.19 8.7 8.7 0 016.2-2.56"/><path fill="#333" d="M14.61 30.66h-1.73a4.3 4.3 0 01-4.3-4.5c.19-2.14.34-3.9.34-4.04 0 .02.85.34.84.5l-.13 1.46-.2 2.17v.2a3.49 3.49 0 003.45 3.35h1.73a3.43 3.43 0 003.4-3.5l-.15-1.73-.17-2.1.86-.11.18 2.14.14 1.73v.31a4.25 4.25 0 01-4.26 4.12"/><path fill="#333" d="M12.4 26.12a.43.43 0 01-.43-.43.43.43 0 01.43-.44l5.8-.04h.01a.43.43 0 010 .86l-5.8.05zm7.9-14.23a.4.4 0 01-.32-.18A9.38 9.38 0 0014.5 7.7a.39.39 0 01-.27-.48.4.4 0 01.48-.28c2.45.67 4.55 2.21 5.92 4.35.11.18.06.43-.12.54a.38.38 0 01-.21.06M14 3.83h-.08a.28.28 0 01-.28-.27V1.1c0-.15.13-.28.28-.28H14c.15 0 .28.13.28.28v2.46c0 .15-.13.27-.28.27m5.72 1.71l-.07-.04a.28.28 0 01-.08-.39l1.36-2.05a.27.27 0 01.38-.08l.07.05c.12.08.16.26.07.38L20.1 5.46a.27.27 0 01-.38.08m3.4 3.8l-.03-.07a.28.28 0 01.11-.37l2.17-1.16c.14-.07.3-.02.37.11l.04.07c.08.14.02.3-.1.38L23.5 9.46a.28.28 0 01-.37-.12m1.19 4.97v-.09a.28.28 0 01.28-.27l2.46.01c.15 0 .27.13.27.28v.09c0 .15-.13.27-.28.27l-2.46-.01a.28.28 0 01-.27-.28M23 19.24l.04-.07a.28.28 0 01.37-.11l2.16 1.18c.13.08.18.24.1.38l-.03.07a.28.28 0 01-.38.11l-2.15-1.19a.28.28 0 01-.11-.37m-18.1-.02l.04.08c.08.13.03.3-.1.37l-2.15 1.2a.28.28 0 01-.37-.1l-.04-.08a.28.28 0 01.1-.37l2.15-1.2c.13-.08.3-.03.37.1"/><g transform="translate(.6 13.97)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#333" d="M3.01.31V.4c0 .15-.12.27-.27.28L.28.7A.27.27 0 010 .44V.35A.28.28 0 01.27.08L2.73.04c.15 0 .28.12.28.27" mask="url(#b)"/></g><path fill="#333" d="M4.83 9.32l-.04.08a.27.27 0 01-.37.11L2.24 8.37A.28.28 0 012.12 8l.04-.07a.27.27 0 01.37-.12l2.19 1.14c.13.07.18.24.11.37m3.43-3.78l-.07.05a.28.28 0 01-.38-.08L6.44 3.47a.28.28 0 01.07-.38l.07-.05a.28.28 0 01.38.08l1.38 2.04c.08.12.05.3-.08.38"/></g></svg>
        </span>
      </div>
      <div class="fact-box__grid-right">
        <h4 v-if="title !== ''" class="fact-box__title">{{ title }}</h4>
        <p class="fact-box__text" v-if="body !== ''">{{ body }}</p>
        <ul class="fact-box__list" v-if="showSupport">
          <li class="fact-box__item">
            <strong>Email:</strong>
            <a class="fact-box__link" href="mailto:support@biltorvet.dk"
              >support@biltorvet.dk</a
            >
          </li>
          <li class="fact-box__item">
            <strong>Telefon:</strong>
            <a class="fact-box__link" href="tel:88826260">88 82 62 60</a>
          </li>
        </ul>
      </div>
    </div>
    <a
      v-if="linkText !== null && linkHref !== null"
      class="fact-box__button"
      :href="linkHref"
      :target="linkTarget"
      >{{ linkText }}</a
    >
  </div>
</template>

<script>
export default {
  props: {
    hasBorderDashed: { default: true, type: Boolean },
    hasBackgroundGreen: { default: false, type: Boolean },
    hasImageQuestionMark: { default: false, type: Boolean },
    showSupport: { default: false, type: Boolean },
    title: { default: '', type: String },
    body: { default: '', type: String },
    linkHref: { default: null, type: String },
    linkText: { default: null, type: String },
    linkTarget: { default: null, type: String },
  },
}
</script>

<style lang="scss">
@import 'FactBox.scss';
</style>
